module.exports = __webpack_public_path__ + "img/about.0cabe1cf.jpg";